import React, { useState } from 'react';
import { Typography } from 'fronton-react';
import { questionStyles } from './style';

type QuestionProps = {
	question: string;
	answer: string;
	mobile: boolean;
};
export const Question = ({ question, answer, mobile }: QuestionProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const variant = !mobile ? 'm' : 's';
	const size = !mobile ? 'body_long' : 'body_short';
	const toggleOpen = () => setIsOpen(!isOpen);
	const triangleClassName = `question__triangle ${isOpen ? 'question__triangle__open' : ''}`;
	const answerClassName = `question__answer ${isOpen ? 'question__answer__open' : ''}`;

	return (
		<div className={questionStyles}>
			<div className="question__top" onClick={toggleOpen}>
				<div className={triangleClassName}></div>
				<div className="question__text">
					<Typography variant={variant} size={size}>
						{question}
					</Typography>
				</div>
			</div>
			<div className={answerClassName}>
				<Typography variant={variant} size={size}>
					{answer}
				</Typography>
			</div>
		</div>
	);
};
